import { Component, computed, ChangeDetectionStrategy } from '@angular/core';

import { MatIcon } from '@angular/material/icon';
import { MatListItem } from '@angular/material/list';

import { StyleService } from '@vendasta/galaxy/style-service';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'atlas-theme-switcher',
  imports: [MatIcon, TranslateModule, MatListItem],
  templateUrl: './theme-switcher.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './theme-switcher.component.scss',
})
export class ThemeSwitcherComponent {
  currentTheme = toSignal(this.styleService.activeTheme$);

  icon = computed(() => {
    return this.currentTheme() === 'glxy-light-theme' ? 'brightness_2' : 'wb_sunny';
  });

  text = computed(() => {
    return this.currentTheme() === 'glxy-light-theme'
      ? 'THEME_SWITCHER.SWITCH_TO_DARK'
      : 'THEME_SWITCHER.SWITCH_TO_LIGHT';
  });

  constructor(private styleService: StyleService) {}

  toggleColorScheme(): void {
    this.styleService.toggleLightDark('business-center-client');
  }
}
